﻿export const dynamicAuditHistoryLocaleDict = {
    ru: {
        auditHistoryTitle: 'История изменений',
        valueColumn: 'Значение',
        changedDateColumn: 'Дата изменения',
        changedByColumn: 'Внёс изменения'
    },
    en: {
        auditHistoryTitle: 'Audit History',
        valueColumn: 'Value',
        changedDateColumn: 'Change Date',
        changedByColumn: 'Changed By'
    },
    th: {
        auditHistoryTitle: 'ประวัติการเปลี่ยนแปลง',
        valueColumn: 'ค่า',
        changedDateColumn: 'วันที่เปลี่ยนแปลง',
        changedByColumn: 'เปลี่ยนแปลงโดย'
    },
    tr: {
        auditHistoryTitle: 'Değişiklik geçmişi',
        valueColumn: 'Değer',
        changedDateColumn: 'Değişiklik tarihi',
        changedByColumn: 'Değiştiren'
    }
};
